import {
  FLOW_WISE_RECON,
  REPORT_OPTIONS,
  RETARGET_OPTIONS,
  SBC_REPORT_OPTIONS,
  SOFTPOS,
  VENDOR_REPORT_OPTIONS,
  IMPORTS_REPORT_OPTIONS,
} from './constants';

type reportOptions = {
  easySplitEnabled: boolean;
  isSubscriptionEnabled: boolean;
  isModuleFederated: boolean;
  isRetargetEnabled: boolean;
  isFlowwiseActive: boolean;
  isEPOSApproved: boolean;
  isMerchantImportEnabled: boolean;
};

export const getReportOptions = ({
  easySplitEnabled,
  isSubscriptionEnabled,
  isModuleFederated,
  isRetargetEnabled,
  isFlowwiseActive,
  isEPOSApproved,
  isMerchantImportEnabled,
}: reportOptions) => {
  if (isModuleFederated) return [...SBC_REPORT_OPTIONS];
  const reportOptionsList = [...REPORT_OPTIONS];

  if (isMerchantImportEnabled) {
    return [...IMPORTS_REPORT_OPTIONS];
  }

  if (easySplitEnabled) {
    reportOptionsList.push(...VENDOR_REPORT_OPTIONS);
  }

  if (isSubscriptionEnabled) {
    reportOptionsList.push(...SBC_REPORT_OPTIONS);
  }

  if (isRetargetEnabled) {
    reportOptionsList.push(...RETARGET_OPTIONS);
  }

  if (!isFlowwiseActive) {
    reportOptionsList.splice(
      reportOptionsList.findIndex(option => option.value === FLOW_WISE_RECON),
      1,
    );
  }

  if (!isEPOSApproved) {
    const unwantedOptions = [
      SOFTPOS,
      'SETTLEMENTS_RECON_OFFLINE',
      'SETTLEMENTS_OFFLINE',
      'LEDGER_OFFLINE',
    ];

    reportOptionsList.filter(option => !unwantedOptions.includes(option.key));
  }

  return reportOptionsList;
};
